import { useMutation } from '@apollo/client';
import { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

import { SvbrgChatSessionVariant } from '@/generated/gql/graphql';
import { INTAKE_LIST_NEW_SESSION } from '~/routes/IntakeCreate/IntakeCreateMutation.gql';
import { RouteId } from '~/routes/RouteId';

export const IntakeCreateChat = () => {
  const [create] = useMutation(INTAKE_LIST_NEW_SESSION);
  const [sessionId, setSessionId] = useState<string | null>(null);

  useEffect(() => {
    const func = async () => {
      const result = await create({
        variables: {
          data: {
            variant: SvbrgChatSessionVariant.REQUEST_CHAT,
          },
        },
      });
      const chatSessionId = result.data?.sevenbridges.chatSession.create.id;
      setSessionId(chatSessionId);
    };
    func();
  }, [create]);
  if (!sessionId) return null;

  return <Navigate replace to={RouteId.intakeDetail(sessionId)} />;
};
